// ドロワーメニュー // Drawer menu
jQuery(function($) {
    if ($('#toggle').length > 0) {
		$('#toggle').click(function () {
			$(this).toggleClass('toggle_active');
			$('#drawer_layer').fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				$('nav').addClass('is_open');
				$('nav').removeClass('is_close');
			} else {
				$('nav').removeClass('is_open');
				$('nav').addClass('is_close');
			}
		});

		$('#drawer_layer').click(function () {
			$(this).fadeOut();
			$('#toggle').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			$('nav').removeClass('is_open');
			$('nav').addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function(){
			// if (window.innerWidth <= 768) {
			if ($('#toggle:visible').length > 0) {
				$('#toggle').click();
			}
		});
	}

	// アンカーリンクのスクロール処理 // Anchor link scroll handling
	function scrollToAnchor() {
		var hash = window.location.hash;
		if (hash) {
			// ページ読み込み完了後に実行（他のスクリプトの実行を待つ）
			setTimeout(function() {
				var target = document.querySelector(hash);
				if (target) {
					// CSSのscroll-behavior: smoothとscroll-padding-topを利用
					// scrollIntoView()でネイティブのスクロール機能を使用
					target.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
				}
			}, 300);
		}
	}

	// ページ読み込み時にアンカーリンクを処理
	$(window).on('load', function() {
		scrollToAnchor();
	});

	// DOM読み込み完了時にも処理（ページ遷移時の即時処理）
	$(document).ready(function() {
		if (window.location.hash) {
			scrollToAnchor();
		}
	});

});

